module.exports = __webpack_public_path__ + "static/media/19.694ac284.png";